import { Injectable } from "@angular/core";

export class Utilities {
  constructor() { }
}

@Injectable()
export class GeneralPurpose extends Utilities {
}

@Injectable()
export class ImageUtility extends Utilities {
	imageExists(url): Promise<boolean> {
		return new Promise<boolean>((resolve) => {
			const img = new Image();
			img.onload = () => resolve(true);
			img.onerror = () => resolve(false);
			img.src = url;
		}).then(response => { return response; });
	}
}

@Injectable()
export class StringFormatting extends Utilities { }

@Injectable()
export class Sorting extends Utilities { }

@Injectable()
export class ColorUtility extends Utilities {
  colorStringToIntHash(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    return hash;
  }

  colorHashToHSL(hash: number, sat: number, lum: number): { hue: number, saturation: any, lightness: any } {
    const hue = hash % 360;
    return { hue: hue, saturation: sat + "%", lightness: lum + "%" };
  }

  colorStringToHSL(str: string, s: number, l: number): string {
    const h = this.colorStringToIntHash(str) % 360;
    return "hsl(" + h + ", " + s + "%, " + l + "%)";
  }

  colorStringToHSLHex(str: string): string {
    const hash = this.colorStringToIntHash(str);

    //Convert to HSL to control saturation and lightness
    const hslColor = this.colorHashToHSL(hash, 60, 50);

    return this.hslToHex(hslColor.hue, hslColor.saturation, hslColor.lightness);
  }

  hslToHex(h: number, s: number, l: number): string {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = n => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color)
        .toString(16)
        .padStart(2, "0"); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  }

  rgbToHex(r: number, g: number, b: number): string {
    let hex = Number(r + "" + g + "" + b).toString(16);
    if (hex.length < 2) {
      hex = "0" + hex;
    }
    return "#" + hex;
  }

  colorStringToHex(str: string): string {
    const hash = this.colorStringToIntHash(str);
    let colour = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += ("00" + value.toString(16)).substr(-2);
    }
    return colour;
  }
}
